export function getSessionStorageValue<T>(key: string, initialValue: T): T {
  const item = sessionStorage.getItem(key);
  return item ? JSON.parse(item) : initialValue;
}

export function setSessionStorageValue<T>(key: string, value: T) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function removeSessionStorageItem(key: string) {
  sessionStorage.removeItem(key);
}

export function getLocalStorageValue<T>(key: string, initialValue: T): T {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : initialValue;
}

export function setLocalStorageValue<T>(key: string, value: T) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function removeLocalStorageItem(key: string) {
  localStorage.removeItem(key);
}
